import styled from 'styled-components';
import QModal from '_Components/Modals/QModal/QModal';

export const StyledQModal = styled(QModal)`
  max-width: 1100px !important;
`;
